import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ViewportScroller } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Router, Scroll } from '@angular/router';
import { CoreModule } from '@core/core.module';
import { AnalyticsDirective } from '@core/services/analytics.directive';
import { ApiService } from '@core/services/api.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from "@sentry/angular";
import { LanguageService } from '@shared/services/language.service';
import { TranslationLoaderService } from '@shared/services/translation.service';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { NgxMaskModule } from 'ngx-mask';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

export function getLanguage(languageService: LanguageService) {
  if (!languageService.getWindow()) {
    return 'it';
  }
  return languageService.getWindow().navigator.language == 'it' ? languageService.getWindow().navigator.language : 'en';
}

@NgModule({
  declarations: [
    AppComponent,
    AnalyticsDirective
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'memorabid' }),
    AppRoutingModule,
    FontAwesomeModule,
    CoreModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationLoaderService,
        deps: [ApiService]
      }
    }),
    NgxMaskModule.forRoot(),
    BlockUIModule.forRoot({
      delayStart: 150,
      delayStop: 10
    }),
    BlockUIHttpModule.forRoot({
      requestFilters: [/geteventnotification|gethistory|geteventdateend|getauctionpriceinfo|getcountunreadmessages|get-current-prices|gettotalamount|memorabidevent\/getbypk\/|memorabidevent\/getbyslug/]
    }),
    FormsModule,
    RecaptchaV3Module
  ],
  exports: [
    AnalyticsDirective
  ],
  providers: [
    {
      provide: LOCALE_ID,
      //useValue: "it-IT"
      deps: [LanguageService],
      useFactory: getLanguage
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    }

  ],
  bootstrap: [AppComponent]
})

export class AppModule {

  constructor(private _router: Router, private _viewportScroller: ViewportScroller){

    this._router.events.pipe(
      filter(event => event instanceof Scroll)
    ).subscribe(event => {
      let e = event as Scroll;
      if (e.anchor) {
        // anchor navigation
        /* setTimeout is the core line to solve the solution */
        setTimeout(() => {
          _viewportScroller.scrollToAnchor(e.anchor!);
        })
      } else if (e.position) {
        // backward navigation
        _viewportScroller.scrollToPosition(e.position);
      } else {
        // forward navigation
        _viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }

}
